/**
 * Lazy Load - native IntersectionObserver-based image lazy loading
 */

class LazyLoad {
    constructor() {
        this.images = document.querySelectorAll('img[data-src]');
        this.videos = document.querySelectorAll('video[data-src]');
        if (this.images.length === 0 && this.videos.length === 0) return;
        this.init();
    }

    init() {
        if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(
                (entries) => this.handleIntersection(entries),
                { rootMargin: '200px 0px', threshold: 0.01 }
            );
            this.images.forEach((img) => this.observer.observe(img));
            this.videos.forEach((video) => this.observer.observe(video));
        } else {
            this.loadAll();
        }
    }

    handleIntersection(entries) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const el = entry.target;
                if (el.tagName === 'VIDEO') {
                    this.loadVideo(el);
                } else {
                    this.loadImage(el);
                }
                this.observer.unobserve(el);
            }
        });
    }

    loadImage(img) {
        const src = img.dataset.src;
        if (!src) return;

        img.src = src;

        if (img.dataset.srcset) {
            img.srcset = img.dataset.srcset;
        }

        img.addEventListener('load', () => {
            img.classList.add('is-loaded');
            delete img.dataset.src;
            delete img.dataset.srcset;
        });
    }

    loadVideo(video) {
        const src = video.dataset.src;
        if (!src) return;

        const source = document.createElement('source');
        source.src = src;
        source.type = video.dataset.type || 'video/mp4';
        video.appendChild(source);
        video.load();

        video.addEventListener('loadeddata', () => {
            video.classList.add('is-loaded');
            delete video.dataset.src;
            delete video.dataset.type;
        }, { once: true });
    }

    loadAll() {
        this.images.forEach((img) => this.loadImage(img));
        this.videos.forEach((video) => this.loadVideo(video));
    }
}

export default new LazyLoad();
